import { inject, Pipe, PipeTransform } from '@angular/core';

import { checkAftersalesApproveRights } from '../services/booking/recourse-booking-functions';
import { UserService } from '../services/user-service/user.service';

@Pipe({
  name: 'canUserApproveAutomatedAftersalesBookings',
})
export class AutomatedAftersalesBookingsApprovalPipe implements PipeTransform {
  private readonly userService = inject(UserService);

  public transform(aftersalesBookingsToApprove: number): boolean {
    return checkAftersalesApproveRights(this.userService.getRights()) && aftersalesBookingsToApprove > 0;
  }
}
